import { Deserializable } from './deserializable';

export class CustomerTemplateConfig {
  SitesList = true;
  KPI = {
    Availability: true,
    Reliability: true,
    ServiceHours: true
  };
}

export class SiteTemplateConfig {
  TrainsList = true;
  KPI = {
    Availability: true,
    Reliability: true,
    ServiceHours: true
  };
}

export class TrainTemplateConfig {
  EquipmentTrain = true;
  OperationalProfile = true;
  KPI = {
    Availability: true,
    Reliability: true,
    ServiceHours: true,
    SuccessfulStarts: true,
    Trips: true,
    Alarms: true,
    AveragePower: false,
    PowerGenerated: false

  };
}

export class FlatTemplate implements Deserializable{


  public name?: string = 'DEFAULT';
  public templateId?: number | string = 0;
  public tags?: string[] = [];

  Reports = true;
  Notifications = true;
  LogBook = true;
  Outages = true;
  DMATags = true;

  Customer = new CustomerTemplateConfig();
  Site = new SiteTemplateConfig();
  Train = new TrainTemplateConfig();

  deserialize(raw: any): this {
    Object.assign(this, JSON.parse(raw.templateData));
    this.templateId = raw.templateId;
    return this;
  }

}



// WEBPACK FOOTER //
// ./src/models/FlatTemplate.ts